import { buildWorkflowReadModelsPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'

export const generateWorkflowReadModels = async ({
  workflow,
  cardTypes,
  previousMessages,
  stream = true,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const messages = [...previousMessages]

  messages.push(...buildWorkflowReadModelsPrompt({ workflow, cardTypes }))

  try {
    if (stream) {
      const response = await streamJsonResponses({
        messages,
        aiVersion: workflow.aiVersion,
        onChunkReceived,
        signal: abortController?.signal
      })

      return [response, messages]
    } else {
      const response = await fetchJsonResponse({
        messages,
        aiVersion: workflow.aiVersion,
        signal: abortController?.signal
      })

      return response || null
    }
  } catch (error) {
    return null
  }
}
